/**
 * Gameplay image URLs resolved at build time (only referenced sprites ship in dist/).
 */
import boulderUrl from "./images/boulder.png?url";
import gemUrl from "./images/gem.png?url";
import shieldUrl from "./images/shield.png?url";
import flaskUrl from "./images/flask.png?url";
import flaskCrackUrl from "./images/crack1.png?url";
import flaskCrack2Url from "./images/crack2.png?url";
import flaskShard1Url from "./images/shard-1.png?url";
import flaskShard2Url from "./images/shard-2.png?url";
import buoyUrl from "./images/buoy.png?url";
import chestUrl from "./images/chest.png?url";
import minimizeAimUrl from "./images/minimize-aim.svg?url";
import buttonAdUrl from "./buttons/ad.png?url";
import buttonShakeUrl from "./buttons/shake.png?url";
import buttonClearUrl from "./buttons/clear.png?url";
import buttonShrinkUrl from "./buttons/shrink.png?url";
import buttonDailyUrl from "./buttons/daily.png?url";
import buttonWheelUrl from "./buttons/wheel.png?url";
import puzzlePiece1Url from "./images/puzzle/piece-1.webp?url";
import puzzlePiece2Url from "./images/puzzle/piece-2.webp?url";
import puzzlePiece3Url from "./images/puzzle/piece-3.webp?url";
import puzzlePiece4Url from "./images/puzzle/piece-4.webp?url";

var GAME_IMAGES = {
  boulder: boulderUrl,
  gem: gemUrl,
  shield: shieldUrl,
  flask: flaskUrl,
  flaskCrack: flaskCrackUrl,
  flaskCrack2: flaskCrack2Url,
  flaskShard1: flaskShard1Url,
  flaskShard2: flaskShard2Url,
  buoy: buoyUrl,
  chest: chestUrl,
  minimizeAim: minimizeAimUrl,
  buttonAd: buttonAdUrl,
  buttonShake: buttonShakeUrl,
  buttonClear: buttonClearUrl,
  buttonShrink: buttonShrinkUrl,
  buttonDaily: buttonDailyUrl,
  buttonWheel: buttonWheelUrl,
  puzzlePiece1: puzzlePiece1Url,
  puzzlePiece2: puzzlePiece2Url,
  puzzlePiece3: puzzlePiece3Url,
  puzzlePiece4: puzzlePiece4Url,
};

/** @param {keyof typeof GAME_IMAGES | string} key */
export function gameImageUrl(key) {
  return GAME_IMAGES[key] || "";
}

export function gameplayStaticImageUrls() {
  return [
    GAME_IMAGES.boulder,
    GAME_IMAGES.gem,
    GAME_IMAGES.shield,
    GAME_IMAGES.flask,
    GAME_IMAGES.flaskCrack,
    GAME_IMAGES.flaskCrack2,
    GAME_IMAGES.flaskShard1,
    GAME_IMAGES.flaskShard2,
    GAME_IMAGES.buoy,
    GAME_IMAGES.chest,
    GAME_IMAGES.minimizeAim,
    GAME_IMAGES.buttonAd,
    GAME_IMAGES.buttonShake,
    GAME_IMAGES.buttonClear,
    GAME_IMAGES.buttonShrink,
    GAME_IMAGES.buttonDaily,
    GAME_IMAGES.buttonWheel,
  ].filter(Boolean);
}

export function minimizeAimCursorUrl() {
  return GAME_IMAGES.minimizeAim;
}